import Icon from 'veui/components/Icon'
import { IconAppsSettings } from 'dls-icons-vue'

Icon.register('apps-settings', IconAppsSettings)
